"use strict";

import mixitup from 'mixitup';

jQuery(document).ready(function ($) {
    if ($('.post-cards--overview').length) {

        let selectFilter = document.querySelector('.select-filter');
        let container = document.querySelector('.post-cards--overview');

        let args = {
            selectors: {
                target: '.mix'
            },
            animation: {
                duration: 500
            },

        };
        let mixer = mixitup(container, args);

        selectFilter.addEventListener('change', function () {
            let selector = selectFilter.value;
            mixer.filter(selector);
        });
    }
});
